/**
 * Lightweight in-memory store for the agency identifier.
 *
 * Populated once after the BFF /api/LookUps/validate-agency-name response
 * returns `data.isValid === true` (in AgencySelectionScreen on native, and in
 * AppNavigator.web.tsx bootstrap on web).
 *
 * The stored value is the user-entered agency name (e.g. "Transit-Local") and
 * is sent as the `X-Agency-Id` header on every subsequent API call via the
 * axios request interceptor.
 */
let _agencyId: string | null = null;

export const agencyStorage = {
  set(id: string): void {
    _agencyId = id;
  },
  get(): string | null {
    return _agencyId;
  },
  clear(): void {
    _agencyId = null;
  },
};